export type PopularFeedProps = {
  // Add your props here
};

export type PopularFeedResponse = {
  nodes: Array<Record<'id', string>>;
  pageInfo: {
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    startCursor: string;
    endCursor: string;
  };
};

// These options should be in sync with
// https://bitbucket.org/atlassian/cc-analytics/src/efe2fa0fddf3cb426623a0780c93d3870bed936d/cloud/src/components/feeds-api/routes/popular.ts#lines-29
export type Timeframe = 'day' | 'week' | 'default' | 'month' | 'year';

const TIMEFRAMES: Timeframe[] = ['day', 'default', 'week', 'month', 'year'];
const TIMEFRAME_SET = new Set<string>(TIMEFRAMES);

export const getTimeframe = (param?: string): Timeframe => {
  if (param && TIMEFRAME_SET.has(param)) {
    return param as Timeframe;
  }

  return 'default';
};
